import type { FC } from 'react';

import Page from '@zen/Components/Page';
import SkeletonTableLoading from '@zen/Components/SkeletonTableLoading';

import { getBookingListColumns, getTableId, getTableTitle } from '../../bookingListTableConfiguration';
import useBookingListScope from '../../hooks/useBookingListScope';
import type { BookingListColumn } from '../../types';
import BookingScopes from '../BookingScopes';
import BookShipmentButton from '../BookShipmentButton';

const BookingListSkeleton: FC = () => {
  const { activeScope, setActiveScope } = useBookingListScope();
  const tableId: string = getTableId(activeScope);
  const tableTitle: string = getTableTitle(activeScope);
  const columns: BookingListColumn[] = getBookingListColumns(activeScope);

  return (
    <Page actionButtons={<BookShipmentButton />} title="Bookings">
      <BookingScopes activeScope={activeScope} isLoading={true} kpiCounts={undefined} onScopeChange={setActiveScope} />
      <div className="mt-4" data-component="booking-list-skeleton">
        <SkeletonTableLoading columns={columns} tableId={tableId} title={tableTitle} />
      </div>
    </Page>
  );
};

export default BookingListSkeleton;
